function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useTheme } from 'styled-components';
var BirminghamMidshiresIcon = function BirminghamMidshiresIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 11V13H0V11H24Z",
    fill: "currentColor"
  }));
};
BirminghamMidshiresIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BlackHorseIcon = function BlackHorseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 13V11H24V13H0Z",
    fill: "currentColor"
  }));
};
BlackHorseIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
    y: "9",
    width: "24",
    height: "5.3333",
    fill: "currentColor"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 11V13H0V11H24Z",
    fill: "currentColor"
  }));
};
HalifaxIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsReimaginedIcon = function LloydsReimaginedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.5H1.5C0.675 13.5 0 12.825 0 12C0 11.175 0.675 10.5 1.5 10.5H22.5C23.325 10.5 24 11.175 24 12C24 12.825 23.325 13.5 22.5 13.5Z",
    fill: "currentColor"
  }));
};
LloydsReimaginedIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
    y: "9",
    width: "24",
    height: "5.3333",
    fill: "currentColor"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 13.5C23.5 13.3741 24 12.8747 24 12.0018C24 11.1288 23.5 10.6282 22.5 10.5H1.5C0.794267 10.502 0.00211325 11.2764 8.62704e-06 12.0018C-0.00300228 12.7316 0.782656 13.5012 1.5 13.5H22.5Z",
    fill: "currentColor"
  }));
};
MbnaIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
    y: "11",
    width: "24",
    height: "2",
    rx: "1",
    fill: "currentColor"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { LLOYDS, BIRMINGHAM_MIDSHIRES, BLACK_HORSE, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT, BOS, HALIFAX, LLOYDS2023, MBNA, SCOTTISH_WIDOWS } from "../../constants";
export default function Minus(_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme();
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.minus) {
    svg = theme.assets.icons.minus;
  } else {
    switch (brand) {
      case BIRMINGHAM_MIDSHIRES:
        svg = BirminghamMidshiresIcon;
        break;
      case BLACK_HORSE:
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = BlackHorseIcon;
        break;
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsReimaginedIcon;
        break;
      case LLOYDS2023:
        svg = Lloyds2023Icon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      default:
        console.warn("Icon \"Minus\" is not available for brand ".concat(brand));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}